export default class PvApiTooManyRequestsException extends Error {
    constructor() {
        super();
        this.name = '429 Too Many Requests';
        this.message = 'Слишком много запросов';
    }
}